export const breakPointsXs = 425;
export const breakPointsSm = 768;
export const breakPointsMd = 992;
export const breakPointsLg = 1024;
export const breakPointsXl = 1440;
